var React = require('react');

function PlayButton (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M44 1.66663H12C6.10894 1.66663 1.33331 6.44225 1.33331 12.3333V33.6666C1.33331 39.5577 6.10894 44.3333 12 44.3333H44C49.891 44.3333 54.6666 39.5577 54.6666 33.6666V12.3333C54.6666 6.44225 49.891 1.66663 44 1.66663Z","fill":"white","stroke":"black","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M34.5708 23.8575C35.2181 23.4691 35.2181 22.5309 34.5708 22.1425L24.1811 15.9087C23.5146 15.5088 22.6666 15.9889 22.6666 16.7662V29.2338C22.6666 30.0111 23.5146 30.4912 24.1811 30.0913L34.5708 23.8575Z","fill":"currentColor","key":1})]);
}

PlayButton.defaultProps = {"width":"56","height":"46","viewBox":"0 0 56 46","fill":"none"};

module.exports = PlayButton;

PlayButton.default = PlayButton;
